import CarouselCard from "./CarouselCard";
import React from "react";
import "keen-slider/keen-slider.min.css";
import { useKeenSlider } from "keen-slider/react";
import Image from "next/image";
import { useState } from "react";

function Arrow(props) {
  return props.left ? (
    <Image
      onClick={props.onClick}
      className="arrow arrow--left"
      src={`${props.svgSrc}/carousel-left.svg`}
      alt="Left arrow"
      width={52}
      height={52}
    />
  ) : (
    <Image
      onClick={props.onClick}
      src={`${props.svgSrc}/carousel-right.svg`}
      alt="Right arrow"
      className="arrow arrow--right"
      width={52}
      height={52}
    />
  );
}

const Carousel = (props) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [loaded, setLoaded] = useState(false);
  const slidesPerView = Object.values(props.quotes).some(
    (quote) => quote.imgUrl
  )
    ? 1.5
    : 2;

  const [sliderRef, instanceRef] = useKeenSlider({
    loop: true,
    centered: true,
    renderMode: "performance",
    slides: { origin: "center", spacing: 40, perView: slidesPerView },
    initial: 0,
    slideChanged(slider) {
      setCurrentSlide(slider.track.details.rel);
    },
    created() {
      setLoaded(true);
    },
    breakpoints: {
      "(max-width: 768px)": {
        slides: { origin: "center", spacing: 10, perView: 1.2 },
      },
    },
  });

  return (
    <section className="carousel full">
      <div className="navigation-wrapper">
        <div ref={sliderRef} className="keen-slider">
          {Object.entries(props.quotes).map(([key, slide], i) => (
            <CarouselCard
              {...slide}
              current={currentSlide === i}
              onClick={() => {
                !(currentSlide === i) && instanceRef.current?.moveToIdx(i);
              }}
              key={key}
            />
          ))}
        </div>
        {loaded && (
          <>
            <Arrow
              left
              onClick={(e) =>
                e.stopPropagation() || instanceRef.current?.prev()
              }
              svgSrc={props.svgSrc}
            />

            <Arrow
              onClick={(e) =>
                e.stopPropagation() || instanceRef.current?.next()
              }
              svgSrc={props.svgSrc}
            />
          </>
        )}
      </div>
    </section>
  );
};

export default Carousel;
